import { Component, OnInit } from '@angular/core';
import { ProductModelService } from '../../../services/product-model.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-models',
  templateUrl: './list-product-models.component.html',
  styleUrls: ['./list-product-models.component.css'],
  providers:[ProductModelService, ProductService]
})
export class ListProductModelsComponent implements OnInit {

  productModels:any = [];

  constructor(private productModelService:ProductModelService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductModels();
  }

  getProductModels(){
    this.productModelService.query({})
      .subscribe((productModels) => {
        this.productModels = productModels;
        this.parseProducts();
      });
  }


  parseProducts(){
    this.productModels.forEach(function (productModel){
      productModel.productTypes = "";
      if(productModel.product_types.includes("1")){
        productModel.productTypes += "Móviles y Tablets,";
      }
      if(productModel.product_types.includes("2")){
        productModel.productTypes += "Consolas,";
      }
      if(productModel.product_types.includes("3")){
        productModel.productTypes += "Artículos Varios,";
      }
      if(productModel.product_types.includes("4")){
        productModel.productTypes += "PC's-portátiles,";
      }
      productModel.productTypes = productModel.productTypes.substring(0,productModel.productTypes.length - 1);
    });
  }

  delete(productModel){
    this.productService.query({model:productModel.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productModelService.delete(productModel.id)
        .subscribe((productModel) => {
          this.getProductModels()
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-models/list-product-models/list-product-models.component.ts